import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';


const loadCustomLinks = (filter) => {
  const query = qs.stringify(_.defaults(filter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/routes${query}`);
  }
  return axiosAPI.get('/routes');
};

const createCustomLinks = (newCustomLink) => {
  return axiosAPI.post('/routes', newCustomLink);
};

const loadCustomLinkById = (customLinkId) => {
  return axiosAPI.get(`/routes/${customLinkId}`);
};

const updateCustomLinkById = (customLinkId, payload) => {
  return axiosAPI.put(`/routes/${customLinkId}`, payload);
};

const deleteCustomLinkById = (customLinkId) => {
  return axiosAPI.delete(`/routes/${customLinkId}`);
};

export {
  loadCustomLinks,
  loadCustomLinkById,
  createCustomLinks,
  updateCustomLinkById,
  deleteCustomLinkById,
};
